import { render, staticRenderFns } from "./BeneficiaryTable.vue?vue&type=template&id=3532bad0&scoped=true"
import script from "./BeneficiaryTable.vue?vue&type=script&lang=ts"
export * from "./BeneficiaryTable.vue?vue&type=script&lang=ts"
import style0 from "./BeneficiaryTable.vue?vue&type=style&index=0&id=3532bad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3532bad0",
  null
  
)

export default component.exports